import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";

import { completePatientZoomMeetingBillingNote } from "~/providers/api/patientZoomMeetingsService";
import { ReimbursementReportData } from "~/providers/utils/types/consultation/reimbursementReportTypes";

export const useCompletePatientBillingNote = (
  patientId: string,
  sessionId: string,
) => {
  const queryClient = useQueryClient();
  const { mutate: completePatientBillingNoteMutation, isPending } = useMutation(
    {
      mutationFn: (reportData: ReimbursementReportData) =>
        completePatientZoomMeetingBillingNote({
          patientId,
          sessionId,
          data: reportData,
        }),
      onError: () =>
        toast.error(
          "We hit trouble completing the billing note. If the issue persists please reload the page!",
        ),
      onSuccess: async () => {
        toast.success("Billing note completed successfully!");
        await queryClient.invalidateQueries({
          queryKey: ["getPatientZoomMeetingBillingNote", patientId, sessionId],
        });
      },
    },
  );

  return { completePatientBillingNoteMutation, isPending };
};
